import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api'; // Not used in this snippet, can be removed if truly unused
import { getCurrentUser } from 'aws-amplify/auth'; // Import from V6
import config from './amplifyconfiguration.json';
import './Home.css';
import './App.css'
import awsmobile from './aws-exports.js';

// Configure Amplify with the settings from amplifyconfiguration.json
Amplify.configure(config);

function Home() {
  const [requestorData, setRequestorData] = useState([]); // Data for "Requested by You"
  const [covererData, setCovererData] = useState([]);     // Data for "Assigned to You"
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [userInfo, setUserInfo] = useState(null); // Stores { email, userId }
  const [activeView, setActiveView] = useState('requested'); // 'requested' or 'assigned'
  const [actionId, setActionId] = useState(null); // Track which item is being deleted/released


  // Function to handle deleting coverage
  const handleDelete = async (coverage) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this coverage request?');
    if (!confirmDelete) return;

    if (!userInfo || !userInfo.userId) { // Ensure userInfo and userId are available
      console.error('User not authenticated for delete operation.');
      return;
    }

    setActionId(coverage.id); // Start spinner
    const cognitoIdToken = localStorage.getItem(
      `CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${userInfo.userId}.idToken`
    );

    const payload = {
      "body": {
        "id": coverage.id,
        "se_email": "NULL",
        "coverage_status": "deleted"
      }
    };
    console.log('Payload being sent to API Gateway (Delete):', payload);

    try {
      const response = await fetch('https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log('Delete Response:', data);

      // Remove the deleted item from the UI
      setRequestorData((prevData) => prevData.filter(item => item.id !== coverage.id));
      setMessage('Coverage successfully deleted');
      setTimeout(() => setMessage(''), 10000);
    } catch (error) {
      console.error('Error deleting coverage:', error);
    } finally {
      setActionId(null); // Stop spinner
    }
  };

  // Function to handle releasing coverage
  const handleRelease = async (coverage) => {
    const confirmRelease = window.confirm('Are you sure you want to release this coverage request?');
    if (!confirmRelease) return;

    if (!userInfo || !userInfo.userId) { // Ensure userInfo and userId are available
      console.error('User not authenticated for release operation.');
      return;
    }

    setActionId(coverage.id); // Start spinner
    const cognitoIdToken = localStorage.getItem(
      `CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${userInfo.userId}.idToken`
    );

    const payload = {
      "body": {
        "id": coverage.id,
        "se_email": "NULL", // Setting se_email to NULL for releasing
        "coverage_status": "claim" // Setting status back to 'claim'
      }
    };
    console.log('Payload being sent to API Gateway (Release):', payload);

    try {
      const response = await fetch('https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      console.log('API Release Response:', data);

      // Remove the released item from the "Assigned to You" UI
      setCovererData((prevData) => prevData.filter(item => item.id !== coverage.id));
      setMessage('Coverage successfully released');
      setTimeout(() => setMessage(''), 10000);

    } catch (error) {
      console.error('Error releasing coverage:', error);
    } finally {
      setActionId(null); // Stop spinner
    }
  };

  // Fetches data for "Requested by You" (where current user is the requestor)
  const fetchDataRequested = async (userEmail, userId) => {
    setError(''); // Clear any previous errors for this fetch

    try {
      const cognitoIdToken = localStorage.getItem(`CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${userId}.idToken`);

      const api_url = 'https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage';
      const filter_key = 'requestor_email';
      const table = "table";
      const table_type = "requests";
      const full_url = `${api_url}?${filter_key}=${userEmail}&${table}=${table_type}`;

      const response = await fetch(full_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API Request Failed (Requested): Status ${response.status}`, errorText);
        throw new Error(`Server responded with status: ${response.status} - ${errorText}`);
      }

      const apiResponse = await response.json();
      console.log('API GET Response (Requested):', apiResponse);
      const responseBody = apiResponse.Items; // Assuming the actual data is in .body.Items

      if (responseBody && Array.isArray(responseBody)) {
        setRequestorData(responseBody); // Correct state update
      } else {
        console.warn("API response body for 'Requested' did not contain an 'Items' array or was empty:", responseBody);
        setRequestorData([]);
      }
    } catch (error) {
      console.error('Error during API call for requested claims:', error);
      setError(`Failed to load requested claims: ${error.message}`);
      setRequestorData([]);
    }
  };

  // Fetches data for "Assigned to You" (where current user is the coverer)
  const fetchDataCovering = async (userEmail, userId) => {
    setError(''); // Clear any previous errors for this fetch

    try {
      const cognitoIdToken = localStorage.getItem(`CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${userId}.idToken`);

      const api_url = 'https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage';
      const filter_key = 'coverer_email';
      const table = "table";
      const table_type = "assignments";
      const full_url = `${api_url}?${filter_key}=${userEmail}&${table}=${table_type}`;

      const response = await fetch(full_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API Request Failed (Covering): Status ${response.status}`, errorText);
        throw new Error(`Server responded with status: ${response.status} - ${errorText}`);
      }

      const apiResponse = await response.json();
      console.log('API GET Response (Covering):', apiResponse);
      const responseBody = apiResponse.Items; // Assuming the actual data is in .body.Items

      if (responseBody && Array.isArray(responseBody)) {
        setCovererData(responseBody);
      } else {
        console.warn("API response body for 'Covering' did not contain an 'Items' array or was empty:", responseBody);
        setCovererData([]);
      }
    } catch (error) {
      console.error('Error during API call for covering claims:', error);
      setError(`Failed to load covering claims: ${error.message}`);
      setCovererData([]);
    }
  };

  // useEffect to load user info and then fetch data
  useEffect(() => {
    const loadUserDataAndFetchAll = async () => {
      setLoading(true); // Start loading
      setError('');      // Clear previous errors

      try {
        const userDetails = await getCurrentUser();
        if (userDetails && userDetails.userId && userDetails.signInDetails && userDetails.signInDetails.loginId) {
          const email = userDetails.signInDetails.loginId;
          const id = userDetails.userId;
          setUserInfo({ email: email, userId: id }); // Store user info in state

          // Fetch both sets of data concurrently
          await Promise.all([
            fetchDataRequested(email, id),
            fetchDataCovering(email, id)
          ]);

        } else {
          setError('User not authenticated or user details incomplete.');
          setUserInfo(null); // Clear user info if not authenticated
        }
      } catch (err) {
        console.error('Error fetching user info or initial data:', err);
        setError('Failed to get user information or load claims.');
        setUserInfo(null);
      } finally {
        setLoading(false); // End loading regardless of success/failure
      }
    };

    loadUserDataAndFetchAll();
  }, []); // Empty dependency array means this runs once on mount

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
      <div>
        {message && <div className="success-message">{message}</div>}

        <div className="toggle-container">
          <div
            className="toggle-active-bg"
            style={{
              transform: activeView === 'requested' ? 'translateX(0%)' : 'translateX(100%)'
            }}
          />
          <button
            className={`toggle-button ${activeView === 'requested' ? 'active' : ''}`}
            onClick={() => setActiveView('requested')}
          >
            Requests
          </button>
          <button
            className={`toggle-button ${activeView === 'assigned' ? 'active' : ''}`}
            onClick={() => setActiveView('assigned')}
          >
            Assigned
          </button>
        </div>
        {activeView === 'requested' && (
          <>
            <h1 className="title home-title">Requested by You</h1>
            <table>
              <thead>
                <tr>
                  <th>SE Name</th>
                  <th>Team Name</th>
                  <th>SE Covering</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {requestorData.length > 0 ? (
                  requestorData.map((coverage) => (
                    <tr key={coverage.id}>
                      <td>{coverage.requestor_name} {coverage.requestor_surname}</td>
                      <td>{coverage.team_name}</td>
                      <td>{coverage.coverer_name} {coverage.coverer_surname}</td>
                      <td>{coverage.coverage_date}</td>
                      <td>
                        <button
                          className={`red-button ${actionId === coverage.id ? "claiming" : ""}`}
                          onClick={() => handleDelete(coverage)}
                          disabled={actionId === coverage.id}
                        >
                          {actionId === coverage.id ? (
                            <>
                              <span className="spinner"></span> Deleting...
                            </>
                          ) : (
                            "Delete"
                          )}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="centered-message">No requests to show</td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}

        {activeView === 'assigned' && (
          <>
            <h1 className="title home-title">Assigned to You</h1>
            <table>
              <thead>
                <tr>
                  <th>SE Name</th>
                  <th>Team Name</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {covererData.length > 0 ? (
                  covererData.map((coverage) => (
                    <tr key={coverage.id}>
                      <td>{coverage.requestor_name} {coverage.requestor_surname}</td>
                      <td>{coverage.team_name}</td>
                      <td>{coverage.coverage_date}</td>
                      <td>
                        <button
                          className={`blue-button ${actionId === coverage.id ? "claiming" : ""}`}
                          onClick={() => handleRelease(coverage)}
                          disabled={actionId === coverage.id}
                        >
                          {actionId === coverage.id ? (
                            <>
                              <span className="spinner"></span> Releasing...
                            </>
                          ) : (
                            "Release"
                          )}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="centered-message">No assignments to show</td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    );
  }

export default Home;
